// cleanup_convert_to_typescript_file_GENERICS

import moment from 'moment';

export const ACTIONS = {
  SET_LOADING: 'setLoading',
  FETCH_SERVICE_SUCCESS: 'fetchServiceSuccess',
  FETCH_ALL_SERVICES_SUCCESS: 'fetchAllServicesSuccess',
  FETCH_ALL_SERVICES_FAILURE: 'fetchAllServicesFailure'
};

const reducer = (state, { payload, type }) => {
  switch (type) {
    case ACTIONS.SET_LOADING:
      return { ...state, loading: payload };
    case ACTIONS.FETCH_SERVICE_SUCCESS:
      return {
        ...state,
        lastSync: moment(),
        loading: false,
        results: state.results.map((result, index) =>
          payload.serviceIndex === index ? payload.newResult : result
        ),
        syncTimes: state.syncTimes.map((time, index) =>
          payload.serviceIndex === index ? moment() : time
        )
      };
    case ACTIONS.FETCH_ALL_SERVICES_SUCCESS:
      return {
        ...state,
        results: payload.results,
        loading: false,
        lastSync: moment(),
        reloads: payload.services.map((service, index) => payload.fetchService(service, index)),
        syncTimes: payload.services.map(() => moment())
      };
    case ACTIONS.FETCH_ALL_SERVICES_FAILURE:
      return {
        ...state,
        loading: false,
        results: [payload]
      };
    default:
      return state;
  }
};

export default reducer;
